// extracted by css-extract-rspack-plugin
export default {"linkButton":"linkButton__NJm2c","block":"block__Wq5cp","loading":"loading__AmMsz","disabled":"disabled__aOHku"};